// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBd6eDCPX6XmkC3heSRjxd6vLFgWbJVuog",
  authDomain: "sports-guardian-pwa.firebaseapp.com",
  projectId: "sports-guardian-pwa",
  storageBucket: "sports-guardian-pwa.appspot.com",
  messagingSenderId: "259013966353",
  appId: "1:259013966353:web:de4194fab65c99f6224fb0"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { app, messaging };